import React, { Fragment, useContext, useEffect } from "react";
import AuthContext from "../../context/auth/AuthContext";
import CardContext from "../../context/card/CardContext";
import PatronRecharge from "./PatronRecharge";
import SponsorRecharge from "./SponsorRecharge";
import usePageTitle from "../../hooks/usePageTitle";

const RechargeCard = (props) => {
  const authContext = useContext(AuthContext);
  const { user } = authContext;
  const cardContext = useContext(CardContext);
  const { selectedCard, clearCurrentCard } = cardContext;

  const {
    match: { params },
  } = props;

  useEffect(() => {
    if (selectedCard) {
      clearCurrentCard();
    }
    //eslint-disable-next-line
  }, []);

  usePageTitle({
    appTitle: props.appTitle,
    pageTitle:
      user.sponsor && params.actionType !== "individual"
        ? "RideSponser Reload"
        : "Patron Reload",
  });

  return (
    <Fragment>
      {user.sponsor && params.actionType !== "individual" ? (
        <SponsorRecharge
          resetUseIdleTimer={props.resetUseIdleTimer}
          mainContentRef={props.mainContentRef}
        />
      ) : (
        <PatronRecharge
          resetUseIdleTimer={props.resetUseIdleTimer}
          mainContentRef={props.mainContentRef}
        />
      )}
    </Fragment>
  );
};

export default RechargeCard;
